export const translations = {
  en: {
    // Navigation
    feed: "Feed",
    directory: "Directory",
    opportunities: "Opportunities",
    messages: "Messages",
    notifications: "Notifications",
    admin: "Admin",
    logout: "Logout",
    profile: "Profile",
    search: "Search",
    back: "Back",
    unknown_label: "Unknown",

    // Auth
    login_title: "Core Access",
    login_subtitle: "Identity Verification Required",
    login_placeholder: "Identity Identifier (Email)",
    password_placeholder: "Access Key",
    login_btn: "Initialize Session",
    forgot_password: "Forgot password?",
    reset_password: "Reset Password",
    back_to_login: "Back to Login",
    send_link: "Send Reset Link",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    change_password: "Change Password",
    password_too_short: "Password must be at least 6 characters.",
    passwords_dont_match: "Passwords don't match.",
    password_changed: "Password changed successfully!",
    access_initialization: "Access Initialization",
    neo_access: "NEO Access",
    register_subtitle: "Register your institutional identity",
    login_subtitle_auth: "Authenticate with your AP credentials",
    email_address: "Email Address",
    identity_identifier: "Identity Identifier",
    access_key: "Access Key",
    authorize_account: "Authorize Account",
    initialize_session: "Initialize Session",
    already_network: "Already within the network?",
    ap_member: "AP Member?",
    sign_in: "Sign In",
    register_link: "Register (@ap-group.org)",
    visiting_us: "Visiting us?",
    guest_access: "Guest Access",
    forgot_password_title: "Forgot Password",
    forgot_password_subtitle: "Enter your email and we'll send you a reset link",
    forgot_password_success: "If that email is registered in the system, you will receive password reset instructions soon.",
    send_reset_link: "Send Reset Link",
    sending: "Sending...",
    reset_token_validating: "Synchronizing security token...",
    reset_token_invalid_title: "Invalid Security Token",
    reset_token_invalid_subtitle: "The reset link has expired or has already been utilized in another session. Please request a new transmission.",
    new_reset_link: "Request New Reset Link",
    reset_success_title: "Access Key Rotated!",
    reset_success_subtitle: "Your access key has been successfully updated. Redirecting to auth gateway in 3 seconds...",
    go_to_login_now: "Proceed to Login Now →",
    new_password_label: "New Access Key",
    confirm_password_label: "Confirm Access Key",
    password_hint_valid: "✓ Access key strength approved",
    password_hint_invalid: "✗ Insufficient length: {count} characters remaining",
    saving: "Synchronizing...",


    // Home / Feed

    start_update: "Start a professional update...",
    publish: "PUBLISH",
    refine: "REFINE",
    post_failed: "Failed to publish post. Please check your network or try again.",
    reaction_insightful: "Insightful",
    reaction_celebrate: "Celebrate",
    reaction_support: "Support",
    reaction_funny: "Funny",
    reaction_like: "Like",
    comment_placeholder: "Add a strategic perspective...",
    load_more: "Load more perspectives",
    no_posts: "No transmissions found in your network perimeter.",

    // Post Tools
    tool_poll: "Network Insight",
    tool_event: "Strategic Event",
    tool_media: "Digital Assets",
    tool_celebration: "Member Recognition",
    poll_question: "Inquiry Statement",
    poll_option: "Option",
    add_option: "Add New Poll Option",
    event_date: "Event Date & Time",
    location: "Location",
    asset_link: "Asset Source Link (Optional)",
    tag_placeholder: "Search colleagues to tag...",

    // Jobs / Opportunities
    jobs_title: "Opportunity Board",
    jobs_subtitle: "Discover high-impact roles in the AP Group ecosystem.",
    search_jobs: "Search title, company, skill...",
    all_types: "All types",
    all_status: "All status",
    applied: "Applied",
    not_applied: "Not applied",
    loading: "Loading...",
    no_jobs: "No opportunities found matching your filters.",
    job_description: "Description",
    experience_years: "years",
    applications: "Applications",
    deadline: "Deadline",
    expired: "Expired",
    apply_now: "Apply Now",
    already_applied: "Already applied",
    application_success: "Application submitted successfully!",
    cover_letter: "Cover Letter",
    optional: "optional",
    cover_letter_placeholder: "Tell us why you are a strategic fit...",
    ai_matching: "AI matching score is calculated based on your profile skills.",
    cancel: "Cancel",
    submit: "Submit",
    remote: "Remote",
    category_project: "Project",
    category_job: "Job",
    category_collab: "Collaboration",
    budget_placeholder: "e.g. 500€",
    timeline_placeholder: "e.g. 2 weeks",
    location_placeholder: "e.g. Remote / Athens",
    type_full_time: "Full-Time",
    type_part_time: "Part-Time",
    type_contract: "Contract",
    type_internship: "Internship",
    type_remote: "Remote",
    status_applied: "Applied",
    status_pending: "Pending",
    status_shortlisted: "Shortlisted",
    status_hired: "Hired",
    status_rejected: "Not Selected",

    // Board
    board_subtitle: "Access strategic opportunities, high-impact roles, and exclusive internships within the AP Group ecosystem.",
    opportunities_tab: "Opportunities",
    jobs_tab: "Strategic Roles",
    internships_tab: "AP Internships",
    new_opportunity: "New Strategic Mission",
    edit_opportunity: "Modify Mission",
    delete_opp_confirm: "Are you certain you wish to abort this mission? This action is irreversible.",
    initiate: "Initiate",
    track: "Track",
    tracking: "Tracking",
    by_user: "by",
    ap_exclusive: "AP NEO Exclusive",
    category_label: "Classification",
    budget_label: "Tactical Budget",
    timeline_label: "Operational Timeline",
    location_label: "Sector / Location",
    title_label: "Mission Title",
    description_label: "Detailed Directives",
    create_mission: "Establish Mission",
    save_mission: "Synchronize Changes",
    no_internships: "No exclusive AP Internships are currently active in this sector.",
    results_found: "matching results",
    mission_category_project: "Strategic Project",
    mission_category_job: "High-Impact Role",
    mission_category_collab: "Tactical Collaboration",

    // General
    save: "Save",
    delete: "Delete",
    confirm: "Confirm",
    error_generic: "An anomaly occurred. Please synchronization again.",
    view_profile: "View Profile",
    my_company: "My Company",
    admin_dashboard: "Admin Dashboard",
    settings: "Settings",
    sign_out: "Sign Out",
    network_level: "Network Level",
    influence_points: "Influence Points",
    connections: "Connections",

    // Engagement & Feed
    comment_single: "comment",
    comment_plural: "comments",
    loading_engagement: "Synchronizing engagement...",
    no_engagement: "No engagement detected in this sector.",
    comment_label_lower: "comment",
    comments_label_lower: "comments",
    voted_label: "Infiltrated Option",
    member_label: "NEO Member",
    save_changes: "Save Changes",
    discard: "Discard",
    delete_post_btn: "Permanently Delete Post",
    vote_single: "vote",
    vote_plural: "votes",
    vote_recorded: "Inquiry recorded (Click to retract)",
    vote_prompt: "Select an option to contribute",
    view_voters: "VIEW CONTRIBUTORS",
    personnel_celebration: "Personnel Celebration",
    also_featuring: "Strategic Collaborators",
    remote_mission: "Remote Mission",
    post_image_alt: "Strategic transmission visual",

    // Notifications & Messages
    no_notifications: "Your notification signal is currently clear.",
    no_messages: "No secure communications found.",
    start_conversation: "Initiate secure channel",

    // Home Sidebar & Stats
    profile_views: "Profile Views",
    total_engagement: "Total Engagement",
    eng_likes: "Likes",
    eng_special: "Special Reactions",
    eng_comments: "Comments",
    network_size: "Network Size",
    manage_identity: "MANAGE PROFESSIONAL IDENTITY",

    // Post Creator & Feed
    start_post_placeholder: "Start a professional update...",
    feed_quiet: "The neural feed is quiet...",
    no_updates_sector: "No professional updates found in this sector.",
    edit_post: "Edit Post",
    delete_post: "Delete Post",
    poll_engagement_title: "Network Poll Participation",
    reactions_modal_title: "Reactions",
    celebration_type_announcement: "Personnel Celebration",

    // Sidebar Specifics
    todays_occasions: "Today's Occasions",
    name_day_label: "Name Day",
    no_celebrations: "No members celebrating today.",
    network_insights: "Network Insights",
    total_members_label: "Total Members",

    // Post Creator Modal
    modify_post_title: "Modify Professional Update",
    compose_post_title: "Compose Professional Update",
    share_insights_placeholder: "Share professional insights or strategic context...",

    // Comments & Actions
    reply: "Reply",
    add_comment: "Add a comment...",
    write_reply: "Write a reply...",
    replying_to: "Replying to",
    comment_action: "Comment",
    share_action: "Share",
    share_title: "Batch Transmission",
    share_complete_title: "Transmission Complete",
    share_subtitle: "Select colleagues for broadcast",
    share_complete_subtitle: "Messages successfully dispatched",
    search_friends_placeholder: "Search friends...",
    clear_selection: "Clear",
    select_all: "Select All",
    personal_note_label: "PERSONAL NOTE (OPTIONAL)",
    personal_note_placeholder: "Add a message here...",
    broadcast_dispatched: "BROADCAST DISPATCHED",
    dispatching: "Dispatching...",
    colleague_single: "COLLEAGUE",
    colleague_plural: "COLLEAGUES",
    broadcast_to_label: "BROADCAST TO",
    sync_connections: "Synchronizing connections...",
    no_matching_connections: "No matching connections found.",
    no_active_connections: "No active connections to share with.",
    save_upper: "SAVE",
    cancel_upper: "CANCEL",
    refine_upper: "REFINE",

    // Poll Creator
    poll_query_placeholder: "What would you like to inquire from the network?",
    poll_options_label: "Poll Options",
    poll_option_placeholder: "Option",
    add_poll_option: "Add New Poll Option",

    // Post Creator Continued
    event_venue: "Event Venue",
    celebration_type_label: "Celebration Type",
    select_recognition_category: "Select Recognition Category...",
    publish_upper: "PUBLISH",

    // Dialogs
    unsaved_changes_title: "Unsaved Changes",
    unsaved_changes_message: "You have unsaved changes in your professional update. Would you like to save them before leaving?",
    delete_post_title: "Delete Post?",
    delete_post_message: "Are you sure that you want to delete this post? This action cannot be undone.",

    // Profile Page
    loading_profile: "Loading profile...",
    professional_member: "Professional Member",
    connected: "Connected",
    pending: "Pending",
    connect: "Connect",
    message: "Message",
    linkedin_account: "LinkedIn Account",
    download_cv: "Download CV",
    about: "About",
    synthesizing: "Synthesizing...",
    ai_enhance: "AI ENHANCE",
    bio_empty: "Professional background summary empty.",
    professional_highlight: "Professional Milestone",
    experience: "Experience",
    experience_empty: "No professional experience recorded.",
    education: "Education",
    education_empty: "No educational background recorded.",
    analytics: "Analytics Dashboard",
    profile_views_side: "Profile Impressions",
    total_engagement_side: "Network Engagement",
    elite_status: "Network Status",
    likes: "Likes",
    special_reactions: "Special Reactions",
    comments_side: "Comments",
    activity: "Activity",
    post_btn: "Post",
    comment_btn_side: "Comment",
    share_btn_side: "Share",
    write_comment_placeholder: "Write a comment...",
    confirm_label: "Confirm?",
    save_btn_upper: "SAVE",
    skills_side: "Skills",
    no_recent_posts: "No recent posts.",
    no_skills_indexed: "No skills indexed.",
    contact: "Contact",
    contact_restricted: "Contact info restricted. Connect with this member to view details.",
    edit_intro: "Edit Intro",
    full_name_label: "Full Name",
    headline_role: "Headline / Role",
    location_availability: "Location / Availability",
    avatar_url_label: "Avatar URL",
    banner_url_label: "Banner URL",
    cv_url_label: "CV / Dossier URL",
    linkedin_url_label: "LinkedIn Profile URL",
    edit_about: "Edit About",
    summary_label: "Summary",
    edit_experience: "Edit Experience",
    role_number: "Role #",
    role_title_placeholder: "Role Title",
    company_placeholder: "Company",
    time_frame_placeholder: "Time Frame",
    description_placeholder: "Description",
    add_experience_btn: "Add Experience",
    edit_education_title: "Edit Education",
    education_number: "Education #",
    institution_placeholder: "Institution",
    degree_placeholder: "Degree",
    year_placeholder: "Year",
    add_education_btn: "Add Education",
    edit_skills_title: "Edit Skills",
    add_skill_placeholder: "Add a skill...",
    add_btn: "Add",
    skills_count_label: "Skills",
    no_skills_yet: "No skills added yet.",

    // Apex Premium Additions
    boost_profile: "Enhance Professional Visibility",
    network_status: "Strategic Network Tier",
    profile_completeness: "Identity Index Completeness",
    elite_tier_desc: "You are positioned within the top 5% of this professional ecosystem.",
    record_pending: "Professional Record Pending",
    awaiting_index: "Awaiting Tactical Indexing",

    // Members Directory
    member_directory: "Member Directory",
    member_directory_desc: "Professional members indexed within the AP NEO network.",
    search_members_placeholder: "Search by name, role, or skill...",
    all_departments: "All Departments",
    processing: "Processing...",
    pending_cancel: "Pending (Cancel)",
    no_members_found: "NO MEMBERS FOUND MATCHING YOUR SEARCH",
    member_active: "Member Active",
    last_active_label: "Last Active: ",
    never_label: "NEVER",

    // Admin / Command Center
    tab_overview: "Overview",
    tab_personnel: "Personnel",
    tab_companies: "Companies",
    tab_applications: "Applications",
    edit_company: "Edit Company",
    new_company: "New Company",
    company_name_label: "Company Name *",
    industry_label: "Industry",
    location_label_admin: "Location",
    size_label_admin: "Size",
    website_label: "Website",
    logo_url_label: "Logo URL",
    description_label_admin: "Description",
    cancel_btn_admin: "Cancel",
    saving_btn_admin: "Saving...",
    save_btn_admin: "Save",
    create_btn_admin: "Create",
    edit_job_title: "Edit Job",
    new_job_title: "New Job",
    company_label_admin: "Company *",
    position_title_label: "Position Title *",
    job_type_label: "Job Type",
    job_status_label: "Status",
    experience_years_label: "Experience (years)",
    success_fee_label: "Success Fee (€)",
    required_skills_label_admin: "Required Skills (comma separated)",
    deadline_label_admin: "Deadline",
    invite_user_title: "Invite User",
    email_address_label_admin: "Email Address *",
    role_label_admin: "Role *",
    send_invite_btn: "Send Invite",
    active_personnel: "Active Personnel",
    network_posts_stat: "Network Posts",
    opportunities_stat: "Opportunities",
    open_jobs_stat: "Open Jobs",
    pending_apps_stat: "Pending Apps",
    personnel_celebrations: "Personnel Celebrations",
    name_day_today: "NAME DAY TODAY",
    no_celebrations_today: "No celebrations detected for today.",
    platform_users: "Platform Users",
    total_stat: "TOTAL",
    all_roles_filter: "All Roles",
    search_users_placeholder: "Search by name, email, username, or department...",
    table_name: "Name",
    table_email: "Email",
    table_username: "Username",
    table_department: "Department",
    table_role: "Role",
    table_action: "Action",
    no_users_match: "No users match your search.",
    no_personnel_data: "No personnel data available.",
    previous_btn_admin: "Previous",
    next_btn_admin: "Next",
    page_label: "Page {current} of {total}",
    companies_tab_title: "Companies",
    companies_registered_label: "companies registered",
    loading_label_admin: "Loading...",
    no_companies_yet: "No companies yet.",
    click_new_company: "Click 'New Company' to start.",
    verified_label: "Verified",
    open_jobs_label_admin: "open jobs",
    add_job_tooltip: "Add Job",
    edit_tooltip: "Edit",
    delete_tooltip: "Delete",
    jobs_header_admin: "Jobs",
    no_jobs_found_admin: "No jobs. Click + to add.",
    applications_count_label: "applications",
    delete_company_confirm: "Delete company? All jobs will also be deleted.",
    delete_job_confirm_admin: "Delete job?",
    command_center_title: "Command Center",
    command_center_desc: "Global AP NEO oversight and administrative protocols.",
    loading_admin: "Loading Command Center...",
    applications_tab_title: "Job Applications",
    candidate_label: "Candidate",
    score_label: "AI Score",
    date_label: "Date",
    actions_label: "Actions",
    invite_sent_success: "Invite sent to {email}",
    user_role_updated: "User role updated",
    fill_all_fields: "Please fill in all required fields",
    update_failed: "Update failed: ",
    delete_confirm_general: "Are you sure?",
    all_label: "All",
    no_applications_yet: "No applications yet.",
    cancel_btn_admin: "Abort",
    saving_btn_admin: "Saving...",
    save_btn_admin: "Save Changes",
    create_btn_admin: "Create Entry",
    create_company_btn: "Create Company",
    edit_user_title: "Edit User",
    role_ap_member: "AP Member",
    role_member: "Member",
    role_volunteer: "Volunteer",
    role_ap_admin: "AP Admin",
    role_company_admin: "Company Admin",
    role_guest: "Guest",
    role_manager: "Manager",
    role_et_founder: "ET Founder",
    role_et_volunteer: "ET Volunteer",
    account_status_label: "Account Status",
    status_active: "Active",
    status_inactive: "Inactive",
    save_changes_btn: "Save Changes",
    table_status: "Status",
    confirm_toggle_status: "Are you sure you want to change this user's access status?",
    user_updated_success: "User updated successfully",
    salary_range_label: "Salary Range",
    example_company_name: "e.g. AP Ventures",
    example_industry: "e.g. Technology, Finance...",
    example_location: "e.g. Athens",
    example_size: "e.g. 50-200",
    example_location_remote: "e.g. Athens / Remote",
    example_salary: "e.g. 1500-2500€",
    short_description_placeholder: "Short description...",
    detailed_description_placeholder: "Detailed position description...",
    example_job_title: "e.g. Senior Frontend Developer",

    // Messages
    secured_transmission: "SECURED TRANSMISSION",
    access_full_feed: "ACCESS FULL FEED",
    messages_title: "Messages",
    search_messages: "Search messages...",
    active_status: "ACTIVE",
    ready_status: "READY",
    seen_status: "SEEN",
    select_conversation: "SELECT A CONVERSATION TO BEGIN",

    // Notifications
    updates_title: "Updates",
    updates_subtitle: "Real-time activity feed and community connections.",
    pending_requests: "Pending Connection Requests",
    member_fallback: "Member",
    accept: "Accept",
    decline: "Decline",
    archived: "Archived",
    new_update: "New Update",
    no_notifications: "No New Notifications",

    // Company Profile
    verified_company: "Verified",
    website_label: "Website",
    team_label: "Team",
    open_positions_label: "Open Positions",
    no_team_members: "No team members listed",
    no_open_positions: "No open positions right now",
    recent_posts: "Recent Posts",
    loading_company: "Loading company profile...",
    failed_load_company: "Failed to load company",
    company_not_found: "Company not found",

    // Profile Page
    profile_about: "About",
    profile_experience: "Experience",
    profile_education: "Education",
    profile_skills: "Skills",
    profile_contact: "Contact",
    profile_analytics: "Analytics",
    profile_activity: "Activity",
    profile_views: "Profile Views",
    total_engagement: "Total Engagement",
    ai_enhance: "AI Enhance",
    synthesizing: "Synthesizing...",
    no_experience: "No professional experience recorded.",
    no_education: "No educational background recorded.",
    no_skills: "No skills indexed.",
    bio_empty: "Professional background summary empty.",
    edit_intro: "Edit Intro",
    linkedin_account: "LinkedIn Account",
    download_cv: "Download CV",
    professional_member: "Professional Member",
    network_status: "Network Status",
    boost_profile: "Boost Profile"
  },
  gr: {
    // Navigation
    feed: "Ροή",

    // Profile Page
    profile_about: "Σχετικά",
    profile_experience: "Εμπειρία",
    profile_education: "Εκπαίδευση",
    profile_skills: "Δεξιότητες",
    profile_contact: "Επικοινωνία",
    profile_analytics: "Αναλυτικά Στοιχεία",
    profile_activity: "Δραστηριότητα",
    profile_views: "Προβολές Προφίλ",
    total_engagement: "Συνολική Αλληλεπίδραση",
    ai_enhance: "Βελτίωση AI",
    synthesizing: "Σύνθεση...",
    no_experience: "Δεν έχει καταγραφεί επαγγελματική εμπειρία.",
    no_education: "Δεν έχει καταγραφεί εκπαιδευτικό υπόβαθρο.",
    no_skills: "Δεν έχουν καταχωρηθεί δεξιότητες.",
    bio_empty: "Εκκρεμεί Επαγγελματική Καταγραφή.",
    edit_intro: "Επεξεργασία Εισαγωγής",
    linkedin_account: "Λογαριασμός LinkedIn",
    download_cv: "Λήψη Βιογραφικού",
    professional_member: "Επαγγελματικό Μέλος",
    network_status: "Κατάσταση Δικτύου",
    boost_profile: "Ενίσχυση Προφίλ",

    directory: "Κατάλογος",
    opportunities: "Ευκαιρίες",
    messages: "Μηνύματα",
    notifications: "Ειδοποιήσεις",
    admin: "Διαχείριση",
    logout: "Αποσύνδεση",
    profile: "Προφίλ",
    search: "Αναζήτηση",
    back: "Πίσω",
    unknown_label: "Άγνωστο",

    // Auth
    login_title: "Πρόσβαση",
    login_subtitle: "Απαιτείται Επαλήθευση Ταυτότητας",
    login_placeholder: "Ταυτότητα (Email)",
    password_placeholder: "Κλειδί Πρόσβασης",
    login_btn: "Είσοδος",
    forgot_password: "Ξέχασες τον κωδικό σου;",
    reset_password: "Επαναφορά Κωδικού",
    back_to_login: "Επιστροφή στο Login",
    send_link: "Αποστολή Συνδέσμου",
    new_password: "Νέος Κωδικός",
    confirm_password: "Επιβεβαίωση Κωδικού",
    change_password: "Αλλαγή Κωδικού",
    password_too_short: "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.",
    passwords_dont_match: "Οι κωδικοί δεν ταιριάζουν.",
    password_changed: "Ο κωδικός άλλαξε επιτυχώς!",
    access_initialization: "Αρχικοποίηση Πρόσβασης",
    neo_access: "Είσοδος NEO",
    register_subtitle: "Δημιουργήστε την εταιρική σας ταυτότητα",
    login_subtitle_auth: "Συνδεθείτε με τα διαπιστευτήρια AP",
    email_address: "Email",
    identity_identifier: "Ταυτότητα",
    access_key: "Κλειδί Πρόσβασης",
    authorize_account: "Έγκριση Λογαριασμού",
    initialize_session: "Είσοδος",
    already_network: "Είστε ήδη στο δίκτυο;",
    ap_member: "Μέλος AP;",
    sign_in: "Σύνδεση",
    register_link: "Εγγραφή (@ap-group.org)",
    visiting_us: "Επισκέπτης;",
    guest_access: "Πρόσβαση Επισκέπτη",
    forgot_password_title: "Επαναφορά Κωδικού",
    forgot_password_subtitle: "Εισάγετε το email σας και θα σας στείλουμε σύνδεσμο επαναφοράς",
    forgot_password_success: "Αν το email είναι καταχωρημένο στο σύστημα, θα λάβετε σύντομα οδηγίες επαναφοράς κωδικού.",
    send_reset_link: "Αποστολή Συνδέσμου",
    sending: "Αποστολή...",
    reset_token_validating: "Επαλήθευση κλειδιού ασφαλείας...",
    reset_token_invalid_title: "Άκυρο Κλειδί Ασφαλείας",
    reset_token_invalid_subtitle: "Ο σύνδεσμος επαναφοράς έχει λήξει ή έχει ήδη χρησιμοποιηθεί. Παρακαλούμε ζητήστε νέα αποστολή.",
    new_reset_link: "Νέος Σύνδεσμος Επαναφοράς",
    reset_success_title: "Ο Κωδικός Άλλαξε!",
    reset_success_subtitle: "Ο κωδικός πρόσβασης ενημερώθηκε επιτυχώς. Μεταφορά στην πύλη εισόδου σε 3 δευτερόλεπτα...",
    go_to_login_now: "Μετάβαση στο Login τώρα →",
    new_password_label: "Νέος Κωδικός",
    confirm_password_label: "Επιβεβαίωση Κωδικού",
    password_hint_valid: "✓ Ο κωδικός είναι αποδεκτός",
    password_hint_invalid: "✗ Χρειάζονται ακόμα {count} χαρακτήρες",
    saving: "Αποθήκευση...",

    // Home / Feed



    start_update: "Ξεκινήστε μια επαγγελματική ενημέρωση...",
    publish: "ΔΗΜΟΣΙΕΥΣΗ",
    refine: "ΕΠΕΞΕΡΓΑΣΙΑ",
    post_failed: "Αποτυχία δημοσίευσης. Παρακαλώ ελέγξτε το δίκτυο.",
    reaction_insightful: "Διορατικό",
    reaction_celebrate: "Εορτασμός",
    reaction_support: "Υποστήριξη",
    reaction_funny: "Αστείο",
    reaction_like: "Μου αρέσει",
    comment_placeholder: "Προσθέστε μια στρατηγική προοπτική...",
    load_more: "Περισσότερες προοπτικές",
    no_posts: "Δεν βρέθηκαν δημοσιεύσεις στο δίκτυό σας.",

    // Post Tools
    tool_poll: "Δημοσκόπηση",
    tool_event: "Στρατηγικό Γεγονός",
    tool_media: "Ψηφιακά Αρχεία",
    tool_celebration: "Αναγνώριση Μέλους",
    poll_question: "Ερώτηση Δημοσκόπησης",
    poll_option: "Επιλογή",
    add_option: "Προσθήκη Επιλογής",
    event_date: "Ημερομηνία & Ώρα",
    location: "Τοποθεσία",
    asset_link: "Σύνδεσμος Αρχείου (Προαιρετικά)",
    tag_placeholder: "Αναζήτηση συναδέλφων...",

    // Jobs / Opportunities
    jobs_title: "Πίνακας Θέσεων Εργασίας",
    jobs_subtitle: "Ανακαλύψτε ρόλους υψηλού αντίκτυπου στο οικοσύστημα του AP Group.",
    search_jobs: "Αναζήτηση με τίτλο, εταιρεία ή δεξιότητα...",
    all_types: "Όλοι οι τύποι",
    all_status: "Όλες οι καταστάσεις",
    applied: "Έχει γίνει αίτηση",
    not_applied: "Χωρίς αίτηση",
    loading: "Φόρτωση δεδομένων...",
    no_jobs: "Δεν βρέθηκαν ευκαιρίες με αυτά τα φίλτρα.",
    job_description: "Περιγραφή Θέσης",
    experience_years: "χρόνια εμπειρίας",
    applications: "Αιτήσεις",
    deadline: "Προθεσμία",
    expired: "Έχει λήξει",
    apply_now: "Αίτηση Τώρα",
    already_applied: "Έχετε ήδη κάνει αίτηση",
    application_success: "Η αίτησή σας υποβλήθηκε επιτυχώς!",
    cover_letter: "Επιστολή Στρατηγικής Πρόθεσης",
    optional: "προαιρετικό",
    cover_letter_placeholder: "Εξηγήστε γιατί ταιριάζετε σε αυτή την αποστολή...",
    ai_matching: "Το AI Matching Score υπολογίζεται βάσει των δεξιοτήτων του προφίλ σας.",
    cancel: "Ακύρωση",
    submit: "Υποβολή",
    remote: "Εξ αποστάσεως",
    category_project: "Project (Έργο)",
    category_job: "Job (Θέση)",
    category_collab: "Collaboration (Συνεργασία)",
    budget_placeholder: "π.χ. 500€",
    timeline_placeholder: "π.χ. 2 εβδομάδες",
    location_placeholder: "π.χ. Εξ αποστάσεως / Αθήνα",
    type_full_time: "Πλήρης Απασχόληση",
    type_part_time: "Μερική Απασχόληση",
    type_contract: "Σύμβαση",
    type_internship: "Πρακτική Άσκηση",
    type_remote: "Εξ αποστάσεως",
    status_applied: "Έχει γίνει αίτηση",
    status_pending: "Εκκρεμεί",
    status_shortlisted: "Στη μικρή λίστα",
    status_hired: "Προσλήφθηκε 🎉",
    status_rejected: "Δεν επιλέχθηκε",
    applied_label: "Έχει γίνει αίτηση",
    shortlisted_label: "Στη μικρή λίστα",
    hired_label: "Προσλήφθηκε 🎉",
    rejected_label: "Δεν επιλέχθηκε",
    match_score: "Ταύτιση",
    applying_for: "Αίτηση για",
    application_expired_msg: "Αυτή η ευκαιρία έχει λήξει.",
    no_jobs_found: "Δεν βρέθηκαν αποστολές",
    positions_found: "ενεργές αποστολές",

    // Board
    board_subtitle: "Πρόσβαση σε στρατηγικές ευκαιρίες, ρόλους υψηλού αντίκτυπου και exclusive internships στο AP Group ecosystem.",
    opportunities_tab: "Ευκαιρίες",
    jobs_tab: "Στρατηγικοί Ρόλοι",
    internships_tab: "AP Internships",
    new_opportunity: "Νέα Στρατηγική Αποστολή",
    edit_opportunity: "Τροποποίηση Αποστολής",
    delete_opp_confirm: "Είστε βέβαιοι ότι θέλετε να ακυρώσετε αυτήν την αποστολή; Η ενέργεια είναι μη αναστρέψιμη.",
    initiate: "Έναρξη",
    track: "Παρακολούθηση",
    tracking: "Παρακολουθείται",
    by_user: "από",
    ap_exclusive: "Αποκλειστικότητα AP NEO",
    category_label: "Κατηγοριοποίηση",
    budget_label: "Τακτικός Προϋπολογισμός",
    timeline_label: "Χρονοδιάγραμμα",
    location_label: "Τομέας / Τοποθεσία",
    title_label: "Τίτλος Αποστολής",
    description_label: "Λεπτομερείς Οδηγίες",
    create_mission: "Δημιουργία Αποστολής",
    save_mission: "Συγχρονισμός Αλλαγών",
    no_internships: "Δεν υπάρχουν ενεργά AP Internships σε αυτόν τον τομέα.",
    results_found: "αποτελέσματα",
    mission_category_project: "Στρατηγικό Project",
    mission_category_job: "Ρόλος Υψηλού Αντίκτυπου",
    mission_category_collab: "Τακτική Συνεργασία",

    // General

    save: "Αποθήκευση",
    delete: "Διαγραφή",
    confirm: "Επιβεβαίωση",
    error_generic: "Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.",
    view_profile: "Προβολή Προφίλ",
    my_company: "Η Εταιρεία μου",
    admin_dashboard: "Πίνακας Διαχείρισης",
    settings: "Ρυθμίσεις",
    sign_out: "Αποσύνδεση",
    network_level: "Επίπεδο Δικτύου",
    influence_points: "Πόντοι Επιρροής",
    connections: "Συνδέσεις",

    // Engagement & Feed
    comment_single: "σχόλιο",
    comment_plural: "σχόλια",
    loading_engagement: "Συγχρονισμός αλληλεπίδρασης...",
    no_engagement: "Δεν βρέθηκε αλληλεπίδραση.",
    voted_label: "Επιλογή",
    member_label: "Μέλος NEO",
    save_changes: "Αποθήκευση Αλλαγών",
    discard: "Απόρριψη",
    delete_post_btn: "Οριστική Διαγραφή Δημοσίευσης",
    vote_single: "ψήφος",
    vote_plural: "ψήφοι",
    vote_recorded: "Η ψήφος καταγράφηκε (Κλικ για ανάκληση)",
    vote_prompt: "Επιλέξτε μια επιλογή για συμμετοχή",
    view_voters: "ΠΡΟΒΟΛΗ ΣΥΜΜΕΤΕΧΟΝΤΩΝ",
    personnel_celebration: "Αναγνώριση Προσωπικού",
    also_featuring: "Συνεργάτες",
    remote_mission: "Απομακρυσμένη Αποστολή",
    post_image_alt: "Εικόνα δημοσίευσης",

    // Notifications & Messages
    no_notifications: "Δεν υπάρχουν ειδοποιήσεις.",
    no_messages: "Δεν υπάρχουν μηνύματα.",
    start_conversation: "Ξεκινήστε συζήτηση",

    // Home Sidebar & Stats
    profile_views: "Προβολές Προφίλ",
    total_engagement: "Συνολική Αλληλεπίδραση",
    eng_likes: "Μου αρέσει",
    eng_special: "Ειδικές Αντιδράσεις",
    eng_comments: "Σχόλια",
    network_size: "Μέγεθος Δικτύου",
    manage_identity: "ΔΙΑΧΕΙΡΙΣΗ ΕΠΑΓΓΕΛΜΑΤΙΚΗΣ ΤΑΥΤΟΤΗΤΑΣ",

    // Post Creator & Feed
    start_post_placeholder: "Ξεκινήστε μια επαγγελματική ενημέρωση...",
    feed_quiet: "Η ροή είναι ήσυχη...",
    no_updates_sector: "Δεν βρέθηκαν ενημερώσεις σε αυτόν τον τομέα.",
    edit_post: "Επεξεργασία",
    delete_post: "Διαγραφή",
    poll_engagement_title: "Συμμετοχή σε Δημοσκόπηση",
    reactions_modal_title: "Αντιδράσεις",
    celebration_type_announcement: "Αναγνώριση Προσωπικού",

    // Sidebar Specifics
    todays_occasions: "Σημερινές Εορτές",
    name_day_label: "Ονομαστική Εορτή",
    no_celebrations: "Δεν υπάρχουν εορτές σήμερα.",
    network_insights: "Στοιχεία Δικτύου",
    total_members_label: "Σύνολο Μελών",

    // Post Creator Modal
    modify_post_title: "Τροποποίηση Ενημέρωσης",
    compose_post_title: "Δημιουργία Ενημέρωσης",
    share_insights_placeholder: "Μοιραστείτε επαγγελματικές γνώσεις ή στρατηγικό πλαίσιο...",

    // Comments & Actions
    reply: "Απάντηση",
    add_comment: "Προσθέστε ένα σχόλιο...",
    write_reply: "Γράψτε μια απάντηση...",
    replying_to: "Απάντηση στον/στην",
    comment_action: "Σχόλιο",
    share_action: "Κοινοποίηση",
    share_title: "Μαζική Μετάδοση",
    share_complete_title: "Η Μετάδοση Ολοκληρώθηκε",
    share_subtitle: "Επιλέξτε συναδέλφους για μετάδοση",
    share_complete_subtitle: "Τα μηνύματα απεστάλησαν επιτυχώς",
    search_friends_placeholder: "Αναζήτηση φίλων...",
    clear_selection: "Εκκαθάριση",
    select_all: "Επιλογή Όλων",
    personal_note_label: "ΠΡΟΣΩΠΙΚΉ ΣΗΜΕΊΩΣΗ (ΠΡΟΑΙΡΕΤΙΚΉ)",
    personal_note_placeholder: "Προσθέστε ένα μήνυμα εδώ...",
    broadcast_dispatched: "Η ΜΕΤΆΔΟΣΗ ΟΛΟΚΛΗΡΏΘΗΚΕ",
    dispatching: "Αποστολή...",
    colleague_single: "ΣΥΝΆΔΕΛΦΟ",
    colleague_plural: "ΣΥΝΑΔΈΛΦΟΥΣ",
    broadcast_to_label: "ΜΕΤΆΔΟΣΗ ΣΕ",
    sync_connections: "Συγχρονισμός συνδέσεων...",
    no_matching_connections: "Δεν βρέθηκαν συνδέσεις που να ταιριάζουν.",
    no_active_connections: "Δεν υπάρχουν ενεργές συνδέσεις για κοινοποίηση.",
    save_upper: "ΑΠΟΘΗΚΕΥΣΗ",
    cancel_upper: "ΑΚΥΡΩΣΗ",
    refine_upper: "ΕΠΕΞΕΡΓΑΣΙΑ",

    // Poll Creator
    poll_query_placeholder: "Τι θα θέλατε να ρωτήσετε το δίκτυο;",
    poll_options_label: "Επιλογές Δημοσκόπησης",
    poll_option_placeholder: "Επιλογή",
    add_poll_option: "Προσθήκη Επιλογής",

    // Post Creator Continued
    event_venue: "Χώρος Εκδήλωσης",
    celebration_type_label: "Τύπος Αναγνώρισης",
    select_recognition_category: "Επιλέξτε Κατηγορία Αναγνώρισης...",
    publish_upper: "ΔΗΜΟΣΙΕΥΣΗ",

    // Dialogs
    unsaved_changes_title: "Μη Αποθηκευμένες Αλλαγές",
    unsaved_changes_message: "Έχετε μη αποθηκευμένες αλλαγές στην ενημέρωσή σας. Θα θέλατε να τις αποθηκεύσετε πριν αποχωρήσετε;",
    delete_post_title: "Διαγραφή Δημοσίευσης;",
    delete_post_message: "Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή τη δημοσίευση; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.",

    // Profile Page
    loading_profile: "Φόρτωση προφίλ...",
    professional_member: "Επαγγελματικό Μέλος",
    connected: "Συνδεδεμένος",
    pending: "Εκκρεμεί",
    connect: "Σύνδεση",
    message: "Μήνυμα",
    linkedin_account: "Λογαριασμός LinkedIn",
    download_cv: "Λήψη Βιογραφικού",
    about: "Σχετικά",
    synthesizing: "Σύνθεση...",
    ai_enhance: "ΒΕΛΤΙΩΣΗ AI",
    bio_empty: "Το επαγγελματικό υπόβαθρο είναι κενό.",
    professional_highlight: "Επαγγελματικό Ορόσημο",
    experience: "Εμπειρία",
    experience_empty: "Δεν έχει καταγραφεί επαγγελματική εμπειρία.",
    education: "Εκπαίδευση",
    education_empty: "Δεν έχει καταγραφεί εκπαιδευτικό υπόβαθρο.",
    analytics: "Αναλυτικά Στοιχεία",
    profile_views_side: "Προβολές Προφίλ",
    total_engagement_side: "Συνολική Αλληλεπίδραση",
    elite_status: "Κατάσταση Δικτύου",
    likes: "Likes",
    special_reactions: "Ειδικές Αντιδράσεις",
    comments_side: "Σχόλια",
    activity: "Δραστηριότητα",
    post_btn: "Δημοσίευση",
    comment_btn_side: "Σχόλιο",
    share_btn_side: "Κοινοποίηση",
    write_comment_placeholder: "Γράψτε ένα σχόλιο...",
    confirm_label: "Επιβεβαίωση;",
    save_btn_upper: "ΑΠΟΘΗΚΕΥΣΗ",
    skills_side: "Δεξιότητες",
    no_recent_posts: "Δεν υπάρχουν πρόσφατες δημοσιεύσεις.",
    no_skills_indexed: "Δεν έχουν καταχωρηθεί δεξιότητες.",
    contact: "Επικοινωνία",
    contact_restricted: "Οι πληροφορίες επικοινωνίας είναι περιορισμένες. Συνδεθείτε με αυτό το μέλος για να δείτε λεπτομέρειες.",
    edit_intro: "Επεξεργασία Εισαγωγής",
    full_name_label: "Ονοματεπώνυμο",
    headline_role: "Τίτλος / Ρόλος",
    location_availability: "Τοποθεσία / Διαθεσιμότητα",
    avatar_url_label: "URL Εικόνας Προφίλ",
    banner_url_label: "URL Εικόνας Εξωφύλλου",
    cv_url_label: "URL Βιογραφικού",
    linkedin_url_label: "URL Προφίλ LinkedIn",
    edit_about: "Επεξεργασία Σχετικά",
    summary_label: "Σύνοψη",
    edit_experience: "Επεξεργασία Εμπειρίας",
    role_number: "Ρόλος #",
    role_title_placeholder: "Τίτλος Ρόλου",
    company_placeholder: "Εταιρεία",
    time_frame_placeholder: "Χρονικό Πλαίσιο",
    description_placeholder: "Περιγραφή",
    add_experience_btn: "Προσθήκη Εμπειρίας",
    edit_education_title: "Επεξεργασία Εκπαίδευσης",
    education_number: "Εκπαίδευση #",
    institution_placeholder: "Ίδρυμα",
    degree_placeholder: "Πτυχίο",
    year_placeholder: "Έτος",
    add_education_btn: "Προσθήκη Εκπαίδευσης",
    edit_skills_title: "Επεξεργασία Δεξιοτήτων",
    add_skill_placeholder: "Προσθήκη δεξιότητας...",
    add_btn: "Προσθήκη",
    skills_count_label: "Δεξιότητες",
    no_skills_yet: "Δεν έχουν προστεθεί δεξιότητες ακόμα.",

    // Apex Premium Additions
    boost_profile: "Ενίσχυση Επαγγελματικής Προβολής",
    network_status: "Στρατηγικό Επίπεδο Δικτύου",
    profile_completeness: "Πληρότητα Δείκτη Ταυτότητας",
    elite_tier_desc: "Βρίσκεστε στο κορυφαίο 5% αυτού του επαγγελματικού οικοσυστήματος.",
    record_pending: "Εκκρεμεί Επαγγελματική Καταγραφή",
    awaiting_index: "Αναμονή Τακτικής Ευρετηρίασης",

    // Members Directory
    member_directory: "Κατάλογος Μελών",
    member_directory_desc: "Επαγγελματικά μέλη καταχωρημένα στο δίκτυο AP NEO.",
    search_members_placeholder: "Αναζήτηση με όνομα, ρόλο ή δεξιότητα...",
    all_departments: "Όλα τα Τμήματα",
    processing: "Επεξεργασία...",
    pending_cancel: "Εκκρεμεί (Ακύρωση)",
    no_members_found: "ΔΕΝ ΒΡΕΘΗΚΑΝ ΜΕΛΗ ΠΟΥ ΝΑ ΤΑΙΡΙΑΖΟΥΝ ΣΤΗΝ ΑΝΑΖΗΤΗΣΗ ΣΑΣ",
    member_active: "Ενεργό Μέλος",
    last_active_label: "Τελευταία δραστηριότητα: ",
    never_label: "ΠΟΤΕ",

    // Admin / Command Center
    tab_overview: "Επισκόπηση",
    tab_personnel: "Προσωπικό",
    tab_companies: "Εταιρείες",
    tab_applications: "Αιτήσεις",
    edit_company: "Επεξεργασία Εταιρείας",
    new_company: "Νέα Εταιρεία",
    company_name_label: "Όνομα Εταιρείας *",
    industry_label: "Κλάδος",
    location_label_admin: "Τοποθεσία",
    size_label_admin: "Μέγεθος",
    website_label: "Website",
    logo_url_label: "Logo URL",
    description_label_admin: "Περιγραφή",
    cancel_btn_admin: "Ακύρωση",
    saving_btn_admin: "Αποθήκευση...",
    save_btn_admin: "Αποθήκευση",
    create_btn_admin: "Δημιουργία",
    edit_job_title: "Επεξεργασία Θέσης",
    new_job_title: "Νέα Θέση Εργασίας",
    company_label_admin: "Εταιρεία *",
    position_title_label: "Τίτλος Θέσης *",
    job_type_label: "Τύπος Θέσης",
    job_status_label: "Κατάσταση",
    experience_years_label: "Εμπειρία (χρόνια)",
    success_fee_label: "Success Fee (€)",
    required_skills_label_admin: "Απαιτούμενες Δεξιότητες (χωρισμένες με κόμμα)",
    deadline_label_admin: "Deadline",
    invite_user_title: "Πρόσκληση Χρήστη",
    email_address_label_admin: "Διεύθυνση Email *",
    role_label_admin: "Ρόλος *",
    send_invite_btn: "Αποστολή Πρόσκλησης",
    active_personnel: "Ενεργό Προσωπικό",
    network_posts_stat: "Δημοσιεύσεις Δικτύου",
    opportunities_stat: "Ευκαιρίες",
    open_jobs_stat: "Ανοιχτές Θέσεις",
    pending_apps_stat: "Εκκρεμείς Αιτήσεις",
    personnel_celebrations: "Εορτασμοί Προσωπικού",
    name_day_today: "ΟΝΟΜΑΣΤΙΚΗ ΕΟΡΤΗ ΣΗΜΕΡΑ",
    no_celebrations_today: "Δεν εντοπίστηκαν εορτασμοί για σήμερα.",
    platform_users: "Χρήστες Πλατφόρμας",
    total_stat: "ΣΥΝΟΛΟ",
    all_roles_filter: "Όλοι οι Ρόλοι",
    search_users_placeholder: "Αναζήτηση με όνομα, email, username ή τμήμα...",
    table_name: "Όνομα",
    table_email: "Email",
    table_username: "Username",
    table_department: "Τμήμα",
    table_role: "Ρόλος",
    table_action: "Ενέργεια",
    no_users_match: "Δεν βρέθηκαν χρήστες που να ταιριάζουν στην αναζήτηση.",
    no_personnel_data: "Δεν υπάρχουν διαθέσιμα δεδομένα προσωπικού.",
    previous_btn_admin: "Προηγούμενο",
    next_btn_admin: "Επόμενο",
    page_label: "Σελίδα {current} από {total}",
    companies_tab_title: "Εταιρείες",
    companies_registered_label: "εταιρείες καταχωρημένες",
    loading_label_admin: "Φόρτωση...",
    no_companies_yet: "Δεν υπάρχουν εταιρείες ακόμα.",
    click_new_company: "Κάντε κλικ στο «Νέα Εταιρεία» για να ξεκινήσετε.",
    verified_label: "Επαληθευμένο",
    open_jobs_label_admin: "ανοιχτές θέσεις",
    add_job_tooltip: "Προσθήκη Θέσης",
    edit_tooltip: "Επεξεργασία",
    delete_tooltip: "Διαγραφή",
    jobs_header_admin: "Θέσεις Εργασίας",
    no_jobs_found_admin: "Δεν υπάρχουν θέσεις. Κάντε κλικ στο + για να προσθέσετε.",
    applications_count_label: "αιτήσεις",
    delete_company_confirm: "Διαγραφή εταιρείας; Θα διαγραφούν και όλες οι θέσεις εργασίας.",
    delete_job_confirm_admin: "Διαγραφή θέσης εργασίας;",
    command_center_title: "Κέντρο Ελέγχου",
    command_center_desc: "Παγκόσμια εποπτεία AP NEO και διοικητικά πρωτόκολλα.",
    loading_admin: "Φόρτωση Κέντρου Ελέγχου...",
    applications_tab_title: "Αιτήσεις Εργασίας",
    candidate_label: "Υποψήφιος",
    score_label: "AI Score",
    date_label: "Ημερομηνία",
    actions_label: "Ενέργειες",
    invite_sent_success: "Η πρόσκληση στάλθηκε στο {email}",
    user_role_updated: "Ο ρόλος του χρήστη ενημερώθηκε",
    fill_all_fields: "Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία",
    update_failed: "Η ενημέρωση απέτυχε: ",
    delete_confirm_general: "Είστε σίγουροι;",
    all_label: "Όλες",
    no_applications_yet: "Δεν υπάρχουν αιτήσεις ακόμα.",
    cancel_btn_admin: "Ακύρωση",
    saving_btn_admin: "Αποθήκευση...",
    save_btn_admin: "Αποθήκευση",
    create_btn_admin: "Δημιουργία",
    create_company_btn: "Δημιουργία Εταιρείας",
    salary_range_label: "Εύρος Μισθού",
    example_company_name: "π.χ. AP Ventures",
    example_industry: "π.χ. Technology, Finance...",
    example_location: "π.χ. Αθήνα",
    example_size: "π.χ. 50-200",
    example_location_remote: "π.χ. Αθήνα / Remote",
    example_salary: "π.χ. 1500-2500€",
    short_description_placeholder: "Σύντομη περιγραφή...",
    detailed_description_placeholder: "Αναλυτική περιγραφή της θέσης...",
    example_job_title: "π.χ. Senior Frontend Developer",
    edit_user_title: "Επεξεργασία Χρήστη",
    role_ap_member: "Μέλος AP",
    role_member: "Μέλος",
    role_volunteer: "Εθελοντής",
    role_ap_admin: "Διαχειριστής AP",
    role_company_admin: "Διαχειριστής Εταιρείας",
    role_guest: "Επισκέπτης",
    role_manager: "Διευθυντής",
    role_et_founder: "Ιδρυτής ET",
    role_et_volunteer: "Εθελοντής ET",
    account_status_label: "Κατάσταση Λογαριασμού",
    status_active: "Ενεργός",
    status_inactive: "Ανενεργός",
    save_changes_btn: "Αποθήκευση Αλλαγών",
    table_status: "Κατάσταση",
    confirm_toggle_status: "Είστε σίγουροι ότι θέλετε να αλλάξετε την κατάσταση πρόσβασης αυτού του χρήστη;",
    user_updated_success: "Ο χρήστης ενημερώθηκε με επιτυχία",

    // Messages
    secured_transmission: "ΑΣΦΑΛΗΣ ΜΕΤΑΔΟΣΗ",
    access_full_feed: "ΠΡΟΣΒΑΣΗ ΣΤΗ ΡΟΗ",
    messages_title: "Μηνύματα",
    search_messages: "Αναζήτηση μηνυμάτων...",
    active_status: "ΕΝΕΡΓΟΣ",
    ready_status: "ΕΤΟΙΜΟΣ",
    seen_status: "ΔΙΑΒΑΣΤΗΚΕ",
    select_conversation: "ΕΠΙΛΕΞΤΕ ΜΙΑ ΣΥΝΟΜΙΛΙΑ ΓΙΑ ΝΑ ΞΕΚΙΝΗΣΕΤΕ",

    // Notifications
    updates_title: "Ενημερώσεις",
    updates_subtitle: "Ροή δραστηριότητας σε πραγματικό χρόνο και συνδέσεις με την κοινότητα.",
    pending_requests: "Εκκρεμή Αιτήματα Σύνδεσης",
    member_fallback: "Μέλος",
    accept: "Αποδοχή",
    decline: "Απόρριψη",
    archived: "Αρχειοθετήθηκε",
    new_update: "Νέα Ενημέρωση",
    no_notifications: "Δεν υπάρχουν νέες ειδοποιήσεις",

    // Company Profile
    verified_company: "Επαληθευμένη",
    website_label: "Ιστοσελίδα",
    team_label: "Ομάδα",
    open_positions_label: "Ανοιχτές Θέσεις",
    no_team_members: "Δεν υπάρχουν μέλη στην ομάδα",
    no_open_positions: "Δεν υπάρχουν ανοιχτές θέσεις αυτή τη στιγμή",
    recent_posts: "Πρόσφατες Δημοσιεύσεις",
    loading_company: "Φόρτωση προφίλ εταιρείας...",
    failed_load_company: "Αποτυχία φόρτωσης εταιρείας",
    comment_label_lower: "σχόλιο",
    comments_label_lower: "σχόλια",
    company_not_found: "Η εταιρεία δεν βρέθηκε"
  }
};
